import axios from "axios";
import { MAIN_URL, getApiHeaders } from "../Configurations/Urls";

const basePath = `${MAIN_URL}/api/ems/institute-settings`;

export async function fetchInstituteSettings(organizationId) {
  const response = await axios.get(basePath, {
    params: { organization_id: organizationId },
    headers: getApiHeaders(),
  });
  return response.data;
}

export async function saveInstituteSettings(payload, asForm = false) {
  if (asForm) {
    const headers = getApiHeaders();
    delete headers["Content-Type"];
    const response = await axios.post(basePath, payload, { headers });
    return response.data;
  }

  const response = await axios.put(basePath, payload, {
    headers: getApiHeaders(),
  });
  return response.data;
}
